/**
 * Branch Options Constants
 *
 * This file contains all the dropdown and selection options for the Branch form.
 * Following the implementation plan for independent branch system.
 *
 * Note: Some options are translated using functions that accept a translation function,
 * following the pattern: getOptionName(t) where t is from useFormsTranslation().
 * Other options still use hardcoded German labels and should be updated in future iterations.
 */

import {
  getCantonOptions,
  getLanguageOptions,
} from './accountGeneralInfoOptions';

// Re-export existing option getters for branch form use
export { getCantonOptions, getLanguageOptions };

/**
 * Days of the week for opening hours (translated)
 */
export const getDayOfWeekOptions = (t: (key: string) => string) =>
  [
    { value: 'monday', label: t('common.daysOfWeek.monday') },
    { value: 'tuesday', label: t('common.daysOfWeek.tuesday') },
    { value: 'wednesday', label: t('common.daysOfWeek.wednesday') },
    { value: 'thursday', label: t('common.daysOfWeek.thursday') },
    { value: 'friday', label: t('common.daysOfWeek.friday') },
    { value: 'saturday', label: t('common.daysOfWeek.saturday') },
    { value: 'sunday', label: t('common.daysOfWeek.sunday') },
  ] as const;

/**
 * Time slots for opening hours (24-hour format)
 */
export const timeSlotOptions = Array.from({ length: 24 * 4 }, (_, index) => {
  const totalMinutes = index * 15;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return { value: timeString, label: timeString };
});

/**
 * Common business hour presets
 */
export const businessHourPresets = [
  {
    value: 'standard',
    label: 'Standard (08:00-17:00)',
    hours: { from: '08:00', to: '17:00' },
  },
  {
    value: 'extended',
    label: 'Erweitert (07:00-19:00)',
    hours: { from: '07:00', to: '19:00' },
  },
  {
    value: 'banking',
    label: 'Banking (09:00-16:00)',
    hours: { from: '09:00', to: '16:00' },
  },
  {
    value: 'retail',
    label: 'Einzelhandel (10:00-20:00)',
    hours: { from: '10:00', to: '20:00' },
  },
] as const;
